import { authFetch } from "../utils/authFetch"
import { API_BASE_URL } from "../config"
// Configuración de la URL base
const BASE_URL = `${API_BASE_URL}/api/empleados`;

/**
 * Obtiene el token del localStorage.
 */


/**
 * Obtiene todos los empleados de una sucursal específica (GET).
 */
export const getEmpleados = async (sucursalId) => {
  const url = `${BASE_URL}/sucursal/${sucursalId}`;

  const response = await authFetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error("Error al consultar los empleados");
  }

  return response.json();
};

/**
 * Obtiene todos los empleados (GET) - Versión de desarrollo.
 */
export const getEmpleadosDev = async () => {
  const response = await authFetch(BASE_URL, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error("Error al consultar los empleados");
  }

  return response.json();
};

/**
 * Crea un nuevo empleado (POST).
 */
export const createEmpleado = async (empleadoData) => {
  const response = await authFetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify(empleadoData),
  });

  if (!response.ok) {
    throw new Error("Error al crear el empleado");
  }

  return response.json();
};

/**
 * Actualiza un empleado existente (PUT).
 */
export const updateEmpleado = async (id, empleadoData) => {
  const url = `${BASE_URL}/${id}`;

  const response = await authFetch(url, {
    method: "PUT",
    body: JSON.stringify(empleadoData),
  });

  if (!response.ok) {
    throw new Error("Error al actualizar el empleado");
  }

  return response.json();
};

/**
 * Obtiene un empleado específico por ID (GET by ID).
 */
export const getEmpleadoById = async (id) => {
  const url = `${BASE_URL}/${id}`;

  const response = await authFetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error("Error al consultar el empleado por ID");
  }

  return response.json();
};